import { createI18n } from 'vue-i18n';
import de from './locales/de';
import en from './locales/en';

export const LOCALES = ['de', 'en'] as const;
export type Locale = (typeof LOCALES)[number];

export const i18n = createI18n({
  legacy: false,
  locale: 'de',
  fallbackLocale: 'de',
  messages: { de, en },
});

const STORAGE_KEY = 'lang';

/** Sprache aus gespeicherter Wahl bzw. Browsereinstellung */
export function detectLocale(): Locale {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'de' || stored === 'en') return stored;
  } catch {
    // Speicher nicht verfügbar (privates Fenster o. Ä.)
  }
  const langs = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const l of langs) {
    const base = l?.slice(0, 2).toLowerCase();
    if (base === 'de' || base === 'en') return base;
  }
  return 'en';
}

export function setLocale(locale: Locale): void {
  i18n.global.locale.value = locale;
  document.documentElement.lang = locale;
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // ignorieren
  }
}

/** Datum im Format der aktuellen Sprache */
export function formatDate(iso: string | Date, opts: Intl.DateTimeFormatOptions = { dateStyle: 'medium' }): string {
  const locale = i18n.global.locale.value === 'de' ? 'de-DE' : 'en-GB';
  return new Intl.DateTimeFormat(locale, opts).format(typeof iso === 'string' ? new Date(iso) : iso);
}
